module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"firmware_set.field.name":"ชื่อ Firmware Set","firmware_set.field.remark":"หมายเหตุ","firmware.field.name":"Version","firmware.field.released_date":"เริ่มใช้งาน","firmware.field.remark":"หมายเหตุ/รายละเอียด"}}')
  delete Component.options._Ctor
}
